"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Stack_1 = __importDefault(require("@mui/material/Stack"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Processing = ({ isProceesing }) => {
    return isProceesing ? ((0, jsx_runtime_1.jsxs)(Stack_1.default, Object.assign({ className: 'wait_stack', justifyContent: 'center', alignItems: 'center', spacing: 2 }, { children: [(0, jsx_runtime_1.jsx)(CircularProgress_1.default, { className: 'wait_icon' }), (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ className: 'wait_text' }, { children: " Please wait ..." }))] }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}));
};
exports.default = Processing;
